
<div class="backgroundDialog" style="width: 100%;  height: 100%; padding: 0px;margin: auto; border: 5px solid rgb(207, 121, 1);">

  <div style="width: 100%; height: 100%; ">

    <div style="text-align: center; width: 5%;display: inline-block;  " >
      <mat-card style="border-radius: 0px 30px 30px 0px ; color: white;
                        background-color: rgb(46, 163, 80); font-size: 20px;">
          &nbsp;&nbsp;Comentario
      </mat-card>
    </div>
    <div style="text-align: right; width: 93%; display: inline-block; " >
      <button  (click)="onNoClick()">
        <img src="../../assets/img/icones/fecharJanela.png" width="100%">
    </button>
    </div>




    <form [formGroup]="formComment" novalidate (ngSubmit)="add()">

      <!--Definir o tamanho da tela-->
      <div style=" width: 100%; overflow:hidden; text-align: center; border-top: 5px solid rgb(207, 121, 1);
                  background-color: rgb(51, 68, 75); text-align: center;">

          <div style="width: 100%; ">

              <table style="width: 98%; margin: 10px;   ">

                <tr>

                  <td style="width: 100%;">

                    <div style=" width: 100%; text-align: center; margin-bottom: 9px;">
                      <label style="color: white;">{{formComment.value.pergDsPergunta}}</label>
                      <label style="color: white; font-weight: 500; margin-left: 10px;">[ {{formComment.value.respDsResposta}} ]</label>
                    </div>

                        <mat-card style="width: 100%; border: 1px solid rgb(51, 68, 75); padding: 5px;
                                background-color:rgb(207, 121, 1);" class="mat-elevation-z4">

                          <table style="text-align: left; width: 100%; height: 98%;">

                                <tr style="cursor: pointer;">
                                  <td style="width: 100%; height: 100%;" >

                                    <mat-card class="mat-elevation-z5" style="font-size: 12px; height: 100%;  padding: 8px;
                                                                              background-color:rgb(252, 247, 242) ">


                                      <table style="width: 100%; background-color: rgb(51, 68, 75); text-align: left;" >
                                        <tr>
                                          <td style="width: 100%; color: white; text-align: center;">
                                            &nbsp;&nbsp;Comentado por: {{formComment.value.usuaNmUsuario}}
                                          </td>

                                        </tr>
                                      </table>

                                      <table style="width: 100%; margin-top: 5px;">
                                        <tr>
                                          <td style="width: 100%; ">
                                            <mat-form-field  appearance="outline">
                                              <mat-label>
                                                <img src="../../assets/img/icones/alteracao.png" width="25px">
                                                Descrição do comentario
                                              </mat-label>
                                              <textarea rows="4" style="resize: none; white-space: pre-line;" matInput formControlName="recmTxComentario" placeholder="Breve descrição do comentário" [readonly]="!data.permParaComentar" ></textarea>
                                            </mat-form-field>
                                          </td>


                                        <tr [hidden]="!data.permParaComentar">
                                          <td  colspan="2" style="width: 100%; ">
                                            
                                            <label *ngIf="moniDhFeedbackAvaliado != null " style="margin-left: 15px;  width: 100%; text-align: center;" > 
                                              Monitoria encerrada <br/>
                                            </label>

                                            <div *ngIf="moniDhFeedbackAvaliado == null " style="width: 100%;">
                                              <div style="width: 70%; float: left;">
                                                <button mat-raised-button  type="button" (click)="criarComment()" [disabled]="clicked"
                                                  style="background-color: rgb(46, 163, 80); color: #fff; width: 99%;  font-size: 12px">
                                                Salvar comentario
                                                </button>
                                              </div>
                                              <div style="width: 30%; float: left;">
                                                <button mat-raised-button color="warn" type="button" (click)="onNoClick()"
                                                          style="color: #fff; width: 99%; font-size: 12px ">
                                                  Cancelar e fechar
                                                </button>
                                              </div>
                                            </div>

                                          </td>
                                        </tr>
                                      </table>


                                    </mat-card>
                                  </td>
                              </tr>

                            </table>

                        </mat-card>

                      </td>
                </tr>

              </table>
        </div>

      </div>

    </form>

  </div>

</div>
